import { useState } from 'react'

const usePlayground = (props: {}) => {
    const [displayComponentKey, setDisplayComponentKey] = useState<string>('Default')

    const handleClickPlayground = (key: string) => () => {
        setDisplayComponentKey(key)
    }

    return {
        displayComponentKey,

        onClickPlayground: handleClickPlayground,
    }
}

export default usePlayground
